
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function CodePlaygroundPreview() {
  const benefits = [
    "Daily updates on relevant current affairs for exams",
    "AI-curated content focused on your specific exam syllabus",
    "Searchable and categorized events for easy revision",
    "Automatic quizzes generated from current news",
    "Connect current events to static syllabus topics",
    "Track your understanding with adaptive tests"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/33bc094b-26ce-4555-a3cb-93d8d930b297.png",
      caption: "Current Affairs - Stay updated with relevant news"
    },
    {
      url: "/lovable-uploads/dec4bd77-fe47-4402-a470-61c7f7814d13.png",
      caption: "Current Affairs - Daily curated content for exam prep"
    }
  ];

  return (
    <FeatureShowcase
      title="AI-Powered Current Affairs"
      description="Stay updated with exam-relevant news and analysis curated specifically for your preparation."
      featureName="Current Affairs"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
